module.exports = __webpack_public_path__ + "img/DE.73978ddf.svg";